import React from 'react';

import { SdmTypography } from './../../../components';

import Divider from '@material-ui/core/Divider';
import { styled } from '@material-ui/core/styles';

const CustomDivider = styled(Divider)({
  backgroundColor: 'white !important',
  opacity: '0.3 !important',
});
const SettingsDivider = ({ text }) => {
  return (
    <div>
      <SdmTypography
        style={{
          font: 'normal normal normal 20px/24px Roboto',
          marginLeft: 16,
        }}
      >
        {text}
      </SdmTypography>
      <CustomDivider variant="middle" />
    </div>
  );
};

export { SettingsDivider };
